import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import SkuflixReplay10Icon from "core/icons/skuflix/SkuflixReplay10Icon";
import ForwardIcon from "@mui/icons-material/Forward";

const PREFIX = "SeekIndicator";

const classes = {
  root: `${PREFIX}-root`,
  icon: `${PREFIX}-icon`,
  text: `${PREFIX}-text`,
};

const Root = styled("div")(({ theme, visible }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 10,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(1),
  backgroundColor: "rgba(0, 0, 0, 0.75)",
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1.5, 2),
  color: "#fff",
  fontSize: "1.5rem",
  fontWeight: 500,
  fontFamily: theme.typography.fontFamily,
  pointerEvents: "none",
  userSelect: "none",
  opacity: visible ? 1 : 0,
  transition: "opacity 0.2s ease-in-out",
  [`& .${classes.icon}`]: {
    fontSize: "2rem",
  },
  [`& .${classes.text}`]: {
    minWidth: "60px",
    textAlign: "center",
  },
}));

function SeekIndicator({ seekAmount }) {
  const [visible, setVisible] = useState(false);
  const [displayAmount, setDisplayAmount] = useState(0);

  useEffect(() => {
    if (seekAmount !== 0) {
      setVisible(true);
      setDisplayAmount(seekAmount); // Сохраняем текущее ненулевое значение
    } else {
      // Начинаем fade-out, но оставляем последнее значение
      const timeout = setTimeout(() => {
        setVisible(false);
      }, 200);
      return () => clearTimeout(timeout);
    }
  }, [seekAmount]);

  if (!visible && seekAmount === 0) {
    return null;
  }

  const isForward = displayAmount > 0;
  const seconds = Math.abs(displayAmount);
  const Icon = isForward ? ForwardIcon : SkuflixReplay10Icon;

  return (
    <Root visible={visible} className={classes.root}>
      <Icon className={classes.icon} />
      <span className={classes.text}>
        {isForward ? "+" : "-"}
        {seconds}s
      </span>
    </Root>
  );
}

SeekIndicator.propTypes = {
  seekAmount: PropTypes.number,
};

SeekIndicator.defaultProps = {
  seekAmount: 0,
};

export default SeekIndicator;
